import Head from "next/head";
import {useRouter} from "next/router";
import {useTranslation} from "ni18n";
import React from "react";
import {PrivacyPolicy} from "src/components/v5/PrivacyPolicy";

import Layout from "../components/v5/Layout";

const PrivacyPolicyPage = () => {
  const i18n = useTranslation();
  const {
    query: {noHeaderFooter},
  } = useRouter();

  return (
    <Layout
      pageTitle={i18n.t("Privacy Policy | Carbon Health")}
      pageDescription={i18n.t("Carbon Health Privacy Policy")}
      noHeader={!!noHeaderFooter}
      noFooter={!!noHeaderFooter}
    >
      <Head>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .privacy-policy h1,
              .privacy-policy h2,
              .privacy-policy h3,
              .privacy-policy h4,
              .privacy-policy p {
                font-weight: 500;
                margin-bottom: 1rem;
              }

              .privacy-policy ul {
                list-style: disc;
                margin: 0 1rem 1rem;
              }

              .privacy-policy li {
                margin: .5rem 1rem;
                line-height: 1.4;
              }

              .privacy-policy a {
                color: #158562;
                text-decoration: underline;
              }
        `,
          }}
        />
      </Head>
      <PrivacyPolicy {...{noHeaderFooter}} />
    </Layout>
  );
};

export default PrivacyPolicyPage;
